// @flow
export { default } from './BannerContent';



// WEBPACK FOOTER //
// ./src/components/banner/BannerContent/index.js